var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClouds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2669_1273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8142 20.25C25.5611 17.9688 24.5404 15.8413 22.9195 14.2163C21.2986 12.5913 19.1737 11.5653 16.8932 11.3063C14.6126 11.0474 12.3118 11.571 10.3679 12.7913C8.42395 14.0116 6.95231 15.8561 6.19423 18.0225C4.45709 18.1647 2.84229 18.9733 1.68784 20.2791C0.533397 21.5849 -0.0712001 23.2866 0.000609828 25.0281C0.0724198 26.7696 0.81507 28.4158 2.07311 29.6221C3.33114 30.8284 5.00703 31.5013 6.74998 31.5H25.875C27.3668 31.4919 28.7944 30.8916 29.8436 29.831C30.8928 28.7704 31.4777 27.3365 31.4696 25.8446C31.4615 24.3528 30.8612 22.9252 29.8006 21.876C28.74 20.8269 27.3061 20.2419 25.8142 20.25V20.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.724 21.9871C32.1915 21.0498 31.4725 20.2316 30.6114 19.583C29.7504 18.9345 28.7656 18.4692 27.7177 18.2161C26.9187 15.1913 25.0041 12.5811 22.3589 10.9106C19.7137 9.24007 16.5341 8.63303 13.4595 9.21157C14.3223 7.62265 15.6435 6.33029 17.2511 5.50272C18.8587 4.67515 20.6782 4.35071 22.4727 4.57162C24.2672 4.79254 25.9537 5.54859 27.3126 6.74135C28.6714 7.9341 29.6398 9.50832 30.0915 11.2591C31.3977 11.1924 32.6863 11.583 33.7357 12.3636C34.7851 13.1443 35.5296 14.2662 35.8413 15.5365C36.1529 16.8067 36.0122 18.1459 35.4432 19.3236C34.8743 20.5013 33.9127 21.4439 32.724 21.9893V21.9871Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2669_1273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/Clouds.bdb79ac6.svg";
export { ForwardRef as ReactComponent };